<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto space-y-8">
      
      <!-- HEADER -->
      <div class="sci-page-header pb-4">
        <div>
          <h1 class="sci-page-title-only">Conferências pelo administrador</h1>
          <p class="text-sm text-slate-500 font-medium mt-1">Busque e confira abastecimentos das prefeituras</p>
        </div>
      </div>

      <!-- BUSCAR FORM -->
      <div class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
          <v-icon color="orange" small>mdi-filter-outline</v-icon>
          <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">FILTROS DE BUSCA</h2>
        </div>
        <div class="p-8">
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Data Inicial</label>
              <Date @dateValue="[(filter.startDate = $event)]" />
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Data Final</label>
              <Date @dateValue="[(filter.endDate = $event)]" />
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mt-4 mb-2">Prefeitura</label>
              <v-autocomplete
                v-model="filter.prefecture_id"
                :items="prefectures"
                item-text="prefecture_social_name"
                item-value="prefecture_id"
                clearable outlined dense hide-details="auto" class="bg-slate-50"
                @change="[getSecretariats(), getVehicles(), getProviders()]"
                placeholder="Selecione a prefeitura"
              />
            </v-col>
            <v-col cols="12" sm="12" md="4">
              <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mt-4 mb-2">Participante</label>
              <v-autocomplete
                :items="providers"
                v-model="filter.provider_id"
                item-value="provider_id"
                item-text="provider_name"
                clearable outlined dense hide-details="auto" class="bg-slate-50"
                placeholder="Selecione o participante"
                @change="getFuelsByProvider"
              />
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mt-4 mb-2">Secretaria</label>
              <v-autocomplete
                v-model="filter.sec_id"
                :items="secretariats"
                item-text="sec_name"
                item-value="sec_id"
                clearable outlined dense hide-details="auto" class="bg-slate-50"
                @change="getVehicles"
                placeholder="Selecione a secretaria"
              />
            </v-col>
            <v-col cols="12" sm="12" md="3">
              <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mt-4 mb-2">Tipo de Combustível</label>
              <v-autocomplete
                v-model="filter.fuel_id"
                :items="fuels"
                item-text="fuel_desc"
                item-value="fuel_id"
                clearable outlined dense hide-details="auto" class="bg-slate-50"
                placeholder="Selecione o combustível"
              />
            </v-col>
          </v-row>
        </div>
        <div class="px-8 py-4 bg-slate-50 border-t border-slate-100 flex justify-end gap-3">
          <v-btn text :loading="loader" v-if="loader"></v-btn>
          <button
            class="bg-orange-500 hover:bg-orange-600 text-white font-bold py-2 px-8 rounded-lg shadow-md shadow-orange-500/20 transition-all transform hover:-translate-y-0.5 text-[11px] uppercase tracking-widest disabled:opacity-50 disabled:cursor-not-allowed"
            @click="getData"
            :disabled="!(filter.startDate && filter.endDate && filter.prefecture_id && filter.provider_id)"
          >
            BUSCAR
          </button>
        </div>
      </div>

      <!-- DESBLOQUEIO DE ABASTECIMENTOS -->
      <div class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-4 flex items-center justify-between" style="background-color: #333333;">
          <div class="flex items-center gap-3">
            <v-icon color="orange" small>mdi-lock-open-outline</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">SELECIONE OS ABASTECIMENTOS PARA DESBLOQUEIO</h2>
          </div>
          <div class="flex items-center">
            <v-tooltip bottom color="primary">
              <template v-slot:activator="{ on, attrs }">
                <button v-bind="attrs" v-on="on" @click="showSearch = !showSearch" class="text-slate-300 hover:text-white transition-colors">
                  <v-icon color="inherit" small>mdi-magnify</v-icon>
                </button>
              </template>
              <span>Pesquisar</span>
            </v-tooltip>
          </div>
        </div>
        <div v-if="showSearch" class="bg-slate-800 px-6 py-2 border-b border-slate-700">
           <v-text-field
             v-model="search"
             dark dense hide-details
             color="#fff"
             placeholder="Digite para pesquisar na tabela..."
             prepend-inner-icon="mdi-magnify"
             append-icon="mdi-close"
             @click:append="showSearch = false"
           />
        </div>
        
        <div class="p-0 text-sm overflow-x-auto">
          <v-data-table
            show-select
            v-model="selectedSupplies"
            :headers="headers"
            :items="dataSupplies"
            :search="search"
            item-key="supply_id"
            class="elevation-0"
            :header-props="{ class: 'bg-slate-50 text-slate-500 font-bold uppercase tracking-wider text-[10px]' }"
          >
            <template v-slot:item.supply_billed="{ item }">
              <v-chip :color="item.supply_billed ? 'info' : 'default'" x-small dark font-bold uppercase>
                {{ item.supply_billed ? "SIM" : "NÃO" }}
              </v-chip>
            </template>
            <template v-slot:item.supply_ajusted="{ item }">
              <v-chip :color="item.supply_ajusted ? 'warning' : 'default'" x-small dark font-bold uppercase>
                {{ item.supply_ajusted ? "SIM" : "NÃO" }}
              </v-chip>
            </template>
            <template v-slot:item.datehour="{ item }">
              <span class="font-medium text-slate-600">{{ convertDateTime(item.datehour) }}</span>
            </template>
            <template v-slot:item.supply_liters_stocked="{ item }">
              <span class="font-bold text-slate-800">{{ item.supply_liters_stocked ? realMaskII(item.supply_liters_stocked) : 0 }}</span>
            </template>
            <template v-slot:item.item_billing_price="{ item }">
              <span class="text-slate-600">{{ item.supply_bidding_price ? realMaskII(item.supply_bidding_price) : 0 }}</span>
            </template>
            <template v-slot:item.total_billing_price="{ item }">
              <span class="font-bold text-emerald-600">{{ item.supply_bidding_price && item.supply_liters_stocked ? realMask((Number(item.supply_bidding_price) * Number(item.supply_liters_stocked)).toFixed(2)) : 0 }}</span>
            </template>
            <template v-slot:item.supply_status="{ item }">
               <v-chip :color="item.supply_status === 'EFETUADO' ? 'success' : 'error'" x-small dark class="font-bold uppercase">
                 {{ item.supply_status }}
               </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
               <div class="flex items-center gap-2">
                 <v-tooltip bottom color="error">
                   <template v-slot:activator="{ on, attrs }">
                     <button v-bind="attrs" v-on="on" @click="deleteSupply(item)" class="text-slate-400 hover:text-red-500 transition-colors">
                       <v-icon color="inherit" small>mdi-delete-outline</v-icon>
                     </button>
                   </template>
                   <span>Excluir Abastecimento</span>
                 </v-tooltip>
               </div>
            </template>
          </v-data-table>
        </div>

        <div class="px-6 py-4 bg-slate-50 border-t border-slate-100 flex items-center justify-between flex-wrap gap-4">
          <div class="flex gap-8 items-center">
            <div class="flex flex-col">
              <span class="text-[9px] font-bold text-slate-400 uppercase tracking-widest">Total Licitado</span>
              <span class="text-sm font-black text-emerald-600">R$ {{ totals.bidding_total ? realMask(Number(totals.bidding_total).toFixed(2)) : '0,00' }}</span>
            </div>
          </div>
          <div class="flex items-center gap-3">
            <v-btn text :loading="loader" v-if="loader"></v-btn>
            <button
              @click="updateSupplies"
              :disabled="(!filter.vehicle_id || selectedSupplies.length == 0)"
              class="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-8 rounded-lg shadow-md shadow-blue-500/20 transition-all transform hover:-translate-y-0.5 text-[11px] uppercase tracking-widest disabled:opacity-50 disabled:cursor-not-allowed"
            >
              DESBLOQUEAR ABASTECIMENTOS
            </button>
          </div>
        </div>
      </div>

      <!-- RESUMO DO VEICULO -->
      <div class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
          <v-icon color="orange" small>mdi-car-info</v-icon>
          <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">RESUMO DO VEÍCULO</h2>
        </div>
        <div class="p-8">
          <v-row>
            <v-col cols="12" md="7">
              <div class="bg-slate-50 rounded-xl p-6 border border-slate-100">
                  <div class="flex flex-col md:flex-row md:items-end gap-4 mb-8">
                    <div class="flex-1">
                      <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Selecionar Veículo para Resumo</label>
                      <v-autocomplete
                        v-model="filter.vehicle_id"
                        :items="vehicles"
                        clearable outlined dense hide-details="auto" class="bg-white"
                        @change="getVehicleData()"
                        item-text="vehicle_board"
                        item-value="vehicle_id"
                        placeholder="Selecione o veículo..."
                      >
                        <template slot="selection" slot-scope="{ item }">
                          <span class="font-bold text-slate-700">{{ item && item.brand_desc ? item.brand_desc : '' }} {{ item && item.model_desc ? item.model_desc : '' }}</span>
                          <v-chip x-small class="ml-2 font-black" color="slate" dark>{{ item ? item.vehicle_board : '' }}</v-chip>
                        </template>
                        <template slot="item" slot-scope="{ item }">
                          <div class="flex items-center justify-between w-full">
                            <span class="text-sm font-medium">{{ item && item.brand_desc ? item.brand_desc : '' }} - {{ item && item.model_desc ? item.model_desc : '' }}</span>
                            <span class="text-[10px] font-black bg-slate-100 px-2 py-0.5 rounded text-slate-600">{{ item ? item.vehicle_board : '' }}</span>
                          </div>
                        </template>
                      </v-autocomplete>
                    </div>
                  </div>
                  
                  <div class="grid grid-cols-2 md:grid-cols-3 gap-6">
                    <div class="space-y-1">
                      <span class="text-slate-400 block text-[9px] font-bold uppercase tracking-wider">Marca/Modelo</span>
                      <span class="font-bold text-slate-800 text-sm leading-tight block">{{ dataVehicle.brand_desc || '-' }} {{ dataVehicle.model_desc || '' }}</span>
                    </div>
                    <div class="space-y-1">
                      <span class="text-slate-400 block text-[9px] font-bold uppercase tracking-wider">Placa</span>
                      <v-chip x-small class="font-black" v-if="dataVehicle.vehicle_board">{{ dataVehicle.vehicle_board }}</v-chip>
                      <span v-else class="font-bold text-slate-800">-</span>
                    </div>
                    <div class="space-y-1">
                      <span class="text-slate-400 block text-[9px] font-bold uppercase tracking-wider">Combustível</span>
                      <span class="font-bold text-slate-800 text-sm">{{ dataVehicle.fuel_desc || '-' }}</span>
                    </div>
                    <div class="col-span-2 space-y-1">
                       <span class="text-slate-400 block text-[9px] font-bold uppercase tracking-wider">Secretaria</span>
                       <span class="font-bold text-slate-800 text-sm block truncate">{{ dataVehicle.sec_name || '-' }}</span>
                    </div>
                     <div class="space-y-1">
                        <span class="text-slate-400 block text-[9px] font-bold uppercase tracking-wider">Média Esperada</span>
                        <span class="font-bold text-slate-800 text-xs block" v-if="dataVehicle && dataVehicle.vehicle_average_consumption_minimum">
                           {{ Number(dataVehicle.vehicle_average_consumption_minimum).toFixed(2) }} - {{ Number(dataVehicle.vehicle_average_consumption_maximum).toFixed(2) }}
                        </span>
                        <span v-else class="font-bold text-slate-800">-</span>
                     </div>

                    <div class="col-span-3 h-px bg-slate-200 my-2"></div>

                    <div class="space-y-1">
                      <span class="text-slate-400 block text-[9px] font-bold uppercase tracking-wider">KM Inicial/Final</span>
                      <span class="font-bold text-slate-800 text-sm block">{{ dataVehicle.initialKM || '0' }} / {{ dataVehicle.lastKM || '0' }}</span>
                      <span class="text-[10px] text-blue-600 font-bold" v-if="dataVehicle.traveledKM">Percorrido: {{ dataVehicle.traveledKM }} KM</span>
                    </div>
                    <div class="space-y-1">
                      <span class="text-slate-400 block text-[9px] font-bold uppercase tracking-wider">Abastecimentos</span>
                      <span class="font-bold text-slate-800 text-sm block">{{ dataVehicle ? (dataVehicle.CountSupplies || '0') : '0' }} registros</span>
                      <span class="text-[10px] text-emerald-600 font-bold" v-if="dataVehicle && dataVehicle.TotalLiters">{{ Number(dataVehicle.TotalLiters).toFixed(2) }} L</span>
                    </div>
                    <div class="space-y-1">
                      <span class="text-slate-400 block text-[9px] font-bold uppercase tracking-wider">Situação de Consumo</span>
                      <div class="flex flex-col gap-1">
                        <span class="font-black text-slate-800 text-sm mb-1">{{ dataVehicle && dataVehicle.Average ? Number(dataVehicle.Average).toFixed(3) : '-' }}</span>
                        <v-chip v-if="resultAverage" :color="resultAverage === 'NA MÉDIA' ? 'success' : 'error'" x-small dark class="font-bold">{{ resultAverage }}</v-chip>
                      </div>
                    </div>
                  </div>
              </div>
            </v-col>
            <v-col cols="12" md="5">
              <div class="bg-white rounded-xl border border-slate-200 h-full overflow-hidden flex flex-col shadow-sm">
                 <div class="bg-slate-50/50 px-6 py-0.5 border-b border-slate-100 flex items-center justify-between">
                    <span class="font-bold text-[9px] uppercase tracking-widest text-slate-400">Últimos Abastecimentos</span>
                    <v-icon size="14" color="slate-300">mdi-history</v-icon>
                 </div>
                 <div class="px-4 pt-2 pb-4 overflow-y-auto max-h-[420px] flex-1">
                    <div class="space-y-4">
                      <div v-for="(ds, index) in dateSupplies" :key="index" class="flex items-center gap-4 group">
                         <div class="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center border border-slate-100 group-hover:bg-blue-50 group-hover:border-blue-100 transition-colors">
                            <v-icon x-small color="slate-400" class="group-hover:text-blue-500">mdi-calendar-check</v-icon>
                         </div>
                         <div class="flex flex-col">
                            <span class="text-xs font-bold text-slate-700">{{ ds.date }}</span>
                            <span class="text-[10px] text-slate-400 font-medium">Abastecimento registrado</span>
                         </div>
                      </div>
                      <div v-if="!dateSupplies || dateSupplies.length === 0" class="flex flex-col items-center justify-center py-12 text-center">
                         <v-icon color="slate-200" large>mdi-file-search-outline</v-icon>
                         <p class="text-[11px] text-slate-400 font-medium mt-2">Nenhum dado encontrado para o período.</p>
                      </div>
                    </div>
                 </div>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>

      <!-- FOOTER / CHECAR TOTAL -->
      <div class="flex justify-end pt-4">
         <v-btn
           color="secondary"
           large
           :to="`/billings/report/conferences/${filter.startDate}/${filter.endDate}/${filter.prefecture_id}/${filter.provider_id}/null`"
           :disabled="!(filter.provider_id && filter.startDate && filter.endDate)"
           class="w-full md:w-auto px-12 tracking-widest font-bold rounded-xl"
           elevation="4"
           dark
           style="background-color: #333333 !important;"
         >
           <v-icon left color="white" class="mr-2">mdi-chart-bar</v-icon> 
           <span class="text-white">CHECAR TOTAL</span>
           <v-icon right color="white" class="ml-4">mdi-open-in-new</v-icon>
         </v-btn>
      </div>

    </div>

    <v-snackbar multi-line :color="snack.color" v-model="snack.show" transition="fade-transition">
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Date from "@/components/InputDate.vue";
import Helpers from "@/mixins/helpers";
export default {
  components: { Date },
  mixins: [Helpers],
  data: () => ({
    showSearch: false,
    search: "",
    prefectures: [],
    secretariats: [],
    vehicles: [],
    singleVehicle: {},
    dataVehicle: {},
    dataSupplies: [],
    dateSupplies: [],
    selectedSupplies: [],
    provider_id: null,
    providers: null,
    fuels: [],
    headers: [
      { text: "Data/Hora", value: "datehour", sortable: false },
      { text: "Item", value: "item_description_desc", sortable: false },
      { text: "Lts Abastecidos", value: "supply_liters_stocked" },
      { text: "Preço Licitado", value: "supply_bidding_price" },
      { text: "T. Licitado", value: "total_billing_price" },
      { text: "NF-e", value: "supply_coupon", sortable: false },
      { text: "Status", value: "supply_status", sortable: false },
      { text: "Corrigido", value: "supply_ajusted", sortable: false },
      { text: "Faturado", value: "supply_billed", sortable: false },
      { text: "Ações", value: "actions", sortable: false, align: 'center' },
    ],
    totals: {
      bidding_total: 0,
      day_value: 0,
      billing_price: 0,
    },
    loader: false,
    resultAverage: null,
    filterSupplies: [],
    filter: {
      vehicle_id: null,
      prefecture_id: null,
      provider_id: null,
      sec_id: null,
      startDate: null,
      endDate: null,
      fuel_id: null,
    },
    snack: {
      show: false,
      message: "",
      color: "",
    },
  }),
  created() {
    this.Helpers;
    this.loader = true;
    this.$store.dispatch("setLoader", this.loader);
    this.$http.get(`/prefectures`).then((r) => {
      this.prefectures = r.data;
      this.loader = false;
      this.$store.dispatch("setLoader", this.loader);
    });
  },
  methods: {
    getProviders() {
      this.$http
        .get(`/providers/prefecture/${this.filter.prefecture_id}`)
        .then((r) => (this.providers = r.data));
    },
    getFuelsByProvider() {
      if (this.filter.prefecture_id && this.filter.provider_id) {
        this.loader = true;
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .get(`/biddings/fuels/${this.filter.prefecture_id}/${this.filter.provider_id}`)
          .then((r) => {
            this.fuels = r.data;
            this.loader = false;
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch(() => {
            this.loader = false;
            this.$store.dispatch("setLoader", this.loader);
          });
      } else {
        this.fuels = [];
        this.filter.fuel_id = null;
      }
    },
    getSecretariats() {
      this.filter.vehicle_id = null;
      this.vehicles = [];
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/distribution/secretariats/${this.filter.prefecture_id}`)
        .then((r) => {
          this.secretariats = r.data;
          this.snack.color = "success";
          this.loader = false;
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    getVehicles() {
      if (this.filter.sec_id || this.filter.prefecture_id) {
        if (this.filter.sec_id) {
          this.loader = true;
          this.$store.dispatch("setLoader", this.loader);
          this.$http
            .get(`/distribution/vehicles/${this.filter.sec_id}`)
            .then((v) => {
              this.vehicles = v.data.filter((veh) => veh.vehicle_active);
              this.loader = false;
              this.snack.color = "success";
              this.$store.dispatch("setLoader", this.loader);
            })
            .catch((e) => {
              this.loader = false;
              this.snack.show = true;
              this.snack.message = e;
              this.snack.type = "error";
              this.$store.dispatch("setLoader", this.loader);
            });
        } else if (this.filter.prefecture_id && !this.filter.sec_id) {
          this.loader = true;
          this.$store.dispatch("setLoader", this.loader);
          this.$http
            .get(
              `/distribution/vehicles/prefecture/${this.filter.prefecture_id}`
            )
            .then((v) => {
              this.vehicles = v.data.filter((veh) => veh.vehicle_active);
              this.loader = false;
              this.snack.color = "success";
              this.$store.dispatch("setLoader", this.loader);
            })
            .catch((e) => {
              this.loader = false;
              this.snack.show = true;
              this.snack.message = e;
              this.snack.type = "error";
              this.$store.dispatch("setLoader", this.loader);
            });
        }
      }
    },
    getSingleVehicle() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/distribution/vehicle/${this.filter.vehicle_id}`)
        .then((v) => {
          this.singleVehicle = v.data[0];
          this.loader = false;
          this.snack.color = "success";
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    getVehicleData() {
      if (this.filter.vehicle_id && this.filter.startDate && this.filter.endDate) {
        this.dateSupplies = [];
        this.dataVehicle = {};
        this.loader = true;
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post(`/distribution/vehicle/data`, this.filter)
          .then((v) => {
            this.dataVehicle = v.data[0];
            this.dateSupplies = v.data[0].dateSupplies;
            this.resultAverage =
              v.data[0].Average < v.data[0].vehicle_average_consumption_minimum
                ? "ABAIXO DA MÉDIA"
                : v.data[0].Average >=
                    v.data[0].vehicle_average_consumption_minimum &&
                  v.data[0].Average <=
                    v.data[0].vehicle_average_consumption_maximum
                ? "NA MÉDIA"
                : "ACIMA DA MÉDIA";

            this.loader = false;
            this.snack.color = "success";
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = e;
            this.snack.type = "error";
            this.$store.dispatch("setLoader", this.loader);
          });
      }
    },
    getData() {
      if (this.filter.prefecture_id) {
        this.totals.day_value = 0;
        this.totals.bidding_total = 0;
        this.dataSupplies = [];
        this.loader = true;
        this.$store.dispatch("setLoader", this.loader);
        this.$http
          .post(`/distribution/econferences/data`, this.filter)
          .then((response) => {
            let dayValue = 0;
            let biddingTotal = 0;

            const mappedSupplies = response.data.map((supply) => {
              dayValue += parseFloat(supply.supply_value || 0);
              biddingTotal += parseFloat(supply.supply_bidding_value || 0);

              return {
                ...supply,
                supply_liters_stocked: Number(supply.supply_liters_stocked || 0).toFixed(3),
                supply_bidding_price: Number(supply.supply_bidding_price || 0).toFixed(3),
                supply_price_day: Number(supply.supply_price_day || 0).toFixed(3),
              };
            });

            this.dataSupplies = mappedSupplies;
            this.totals.day_value = dayValue;
            this.totals.bidding_total = biddingTotal;
            
            this.loader = false;
            this.snack.color = "success";
            this.$store.dispatch("setLoader", this.loader);
          })
          .catch((e) => {
            this.loader = false;
            this.snack.show = true;
            this.snack.message = e;
            this.snack.type = "error";
            this.$store.dispatch("setLoader", this.loader);
          });
      }
    },
    checkSuppliesForVehicle() {
      const vehicle_tank_capacity = Number(this.dataVehicle.vehicle_tank_capacity || 0);
      const vehicle_fuel_type = this.dataVehicle.fuel_desc ? this.dataVehicle.fuel_desc.trim() : "";
      
      const suppliesOnCapacity = this.selectedSupplies.filter(
        (s) => Number(s.supply_liters_stocked || 0) <= vehicle_tank_capacity
      );

      this.filterSupplies = []; // Reset filterSupplies before map

      suppliesOnCapacity.forEach((s) => {
        const itemDesc = s.item_description_desc ? s.item_description_desc.trim() : "";
        
        if (
          vehicle_fuel_type == "FLEX" &&
          (itemDesc == "GASOLINA COMUM" ||
           itemDesc == "GASOLINA ADITIVADA" ||
           itemDesc == "ETANOL COMUM")
        ) {
          this.filterSupplies.push(s);
        } else if (
          vehicle_fuel_type == "GASOLINA" &&
          (itemDesc == "GASOLINA COMUM" ||
           itemDesc == "GASOLINA ADITIVADA")
        ) {
          this.filterSupplies.push(s);
        } else if (
          vehicle_fuel_type == "ETANOL" &&
          itemDesc == "ETANOL COMUM"
        ) {
          this.filterSupplies.push(s);
        } else if (
          (vehicle_fuel_type == "DIESEL" || 
           vehicle_fuel_type == "DIESEL S10" || 
           vehicle_fuel_type == "DIESEL S10/ DIESEL COMUM") &&
          (itemDesc == "ÓLEO DIESEL S10" ||
           itemDesc == "ÓLEO DIESEL S500")
        ) {
          this.filterSupplies.push(s);
        } else if (
          vehicle_fuel_type == "GNV (GÁS NATURAL VEICULAR)" &&
          itemDesc == "GÁS NATURAL VEICULAR"
        ) {
          this.filterSupplies.push(s);
        } else {
          this.snack.show = true;
          this.snack.message = `Combustível "${itemDesc}" inválido para veículo ${vehicle_fuel_type}`;
          this.snack.color = "warning";
        }
      });

      return suppliesOnCapacity;
    },
    updateSupplies() {
      console.log(this.checkSuppliesForVehicle());
      let c = confirm("Deseja desbloquear os abastecimentos selecionados?");
      if (c) {
        this.loader = true;

        if (this.checkSuppliesForVehicle().length > 0) {
          if (this.filterSupplies.length > 0) {
            this.$http
              .put("/distribution/vehicle/data", {
                supplies: this.filterSupplies,
                filter: this.filter,
              })
              .then((r) => {
                this.loader = false;
                this.snack.show = true;
                this.snack.message = r.data.result;
                this.getData();
                this.getVehicleData();
                this.snack.type = "error";
                this.selectedSupplies = [];
                this.filterSupplies = [];
                this.$store.dispatch("setLoader", this.loader);
              })
              .catch((e) => {
                this.selectedSupplies = [];
                this.filterSupplies = [];
                this.loader = false;
                this.snack.show = true;
                this.snack.message = e;
                this.snack.type = "error";
                this.$store.dispatch("setLoader", this.loader);
              });
          } else {
            this.snack.show = true;
            this.loader = false;
            this.selectedSupplies = [];
            this.filterSupplies = [];
            this.snack.message =
              "Um ou mais abastecimentos podem não entrar por ter o tipo de combustivel incompativel com o veiculo.";
            this.snack.color = "warning";
          }
        } else {
          this.loader = false;
          this.snack.show = true;
          this.selectedSupplies = [];
          this.filterSupplies = [];
          this.snack.message =
            "Abastecimento maior que a capacidade do tanque do veículo.";
          this.snack.color = "warning";
        }
      }
    },
    deleteSupply(item) {
      let c = confirm("Deseja realmente excluir este abastecimento? Esta ação não pode ser desfeita.");
      if (c) {
        this.loader = true;
        this.$http.delete(`/supplies/single/${item.supply_id}`)
          .then(() => {
            this.snack.show = true;
            this.snack.message = "Abastecimento excluído com sucesso!";
            this.snack.color = "success";
            this.getData();
            this.loader = false;
          })
          .catch(() => {
            this.snack.show = true;
            this.snack.message = "Erro ao excluir abastecimento.";
            this.snack.color = "error";
            this.loader = false;
          });
      }
    },
  },
};
</script>

<style>
</style>